var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 11,
    r: 10,
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 40.455c0-2.293.44-4.562 1.294-6.68a17.493 17.493 0 013.685-5.663 16.978 16.978 0 015.515-3.783A16.617 16.617 0 0118.5 23c2.233 0 4.443.451 6.506 1.329a16.978 16.978 0 015.515 3.783 17.494 17.494 0 013.685 5.663 17.861 17.861 0 011.294 6.68V46h-34v-5.545z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 31.55L38.228 25 50.5 31.55c0 6.193-.204 12.288-2.271 17.11-1.722 4.016-9.092 7.34-10 7.34-.91 0-8.124-3.059-10.002-7.34-2.197-5.01-2.726-11.695-2.727-17.11z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44.5l8.5-8m0 8l-8.5-8M38.228 25L25.5 31.55c.001 5.415.53 12.1 2.727 17.11C30.105 52.941 37.32 56 38.228 56c.91 0 8.279-3.324 10-7.34 2.068-4.822 2.272-10.917 2.272-17.11L38.228 25z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgVerifError;